import React from 'react';
import { formatPrecio } from '../utils';

function TopBar() {
  return (
    <div style={styles.topbar}>
      <div style={styles.row}>
        <div style={styles.storeInfo}>
          <div style={styles.avatar}>👗</div>
          <div>
            <div style={styles.storeName}>Lupita Fashions MX</div>
            <div style={styles.plan}>⭐ Plan Pro</div>
          </div>
        </div>
        <div style={styles.notif}>🔔</div>
      </div>

      <div style={styles.statsRow}>
        <div style={styles.stat}>
          <div style={styles.statVal}>{formatPrecio(4280)}</div>
          <div style={styles.statLbl}>Hoy</div>
        </div>
        <div style={styles.stat}>
          <div style={styles.statVal}>12</div>
          <div style={styles.statLbl}>Pedidos</div>
        </div>
        <div style={styles.stat}>
          <div style={styles.statVal}>8</div>
          <div style={styles.statLbl}>Productos</div>
        </div>
        <div style={styles.stat}>
          <div style={styles.statVal}>4.9⭐</div>
          <div style={styles.statLbl}>Rating</div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  topbar: {
    background: '#075E54',
    padding: '48px 20px 16px',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 16,
  },
  storeInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  avatar: {
    width: 46,
    height: 46,
    background: '#25D366',
    borderRadius: 14,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 22,
  },
  storeName: {
    color: 'white',
    fontSize: 16,
    fontWeight: 700,
  },
  plan: {
    color: '#a8ffcc',
    fontSize: 11,
    marginTop: 2,
  },
  notif: {
    fontSize: 22,
    cursor: 'pointer',
  },
  statsRow: {
    display: 'flex',
    gap: 8,
  },
  stat: {
    flex: 1,
    background: 'rgba(255,255,255,0.1)',
    borderRadius: 12,
    padding: '10px 8px',
    textAlign: 'center',
  },
  statVal: {
    color: 'white',
    fontSize: 18,
    fontWeight: 800,
  },
  statLbl: {
    color: 'rgba(255,255,255,0.6)',
    fontSize: 10,
    marginTop: 1,
  },
};

export default TopBar;